import {useIsNgwEnabled} from '../../util/rampFeatureFlags/rampFeatureFlags';
import {useMaybeWorkspaceRefsContext} from '../Workspace/WorkspaceRefsContext';

/**
 * Whether NGW is on and the caller is rendering inside a workspace.
 *
 * Both conditions matter: the NGW gate (`useIsNgwEnabled`), and the presence of
 * workspace refs, which the metric search hooks need and which reports and
 * other non-workspace surfaces don't provide. Callers use this to pick between
 * two components rather than branching hooks inside one.
 */
export function useIsNgwEnabledInWorkspace(): boolean {
  const isEnabled = useIsNgwEnabled();
  const workspaceRefs = useMaybeWorkspaceRefsContext();
  return isEnabled && workspaceRefs != null;
}
